// A pessoa pediu ao sistema operacional para reduzir animações?
//
// Fica num lugar só porque a resposta decide três coisas na mesma tela: se a
// contagem dos números anima, se as seções aparecem ao rolar, e se o fundo
// animado chega a ser carregado. Três leituras separadas poderiam discordar
// -- e o jeito de descobrir seria alguém com enjoo de movimento olhando uma
// tela que ignorou a preferência dele em um dos três.
//
// `matchMedia` não existe em todo lugar (jsdom antigo, navegador embutido de
// aplicativo), e lá a resposta correta é "não pediu": na dúvida a tela
// funciona como sempre funcionou.

export const CONSULTA = '(prefers-reduced-motion: reduce)';

/** @returns {boolean} */
export function prefereMovimentoReduzido() {
    try {
        return Boolean(window.matchMedia && window.matchMedia(CONSULTA).matches);
    } catch {
        return false;
    }
}

/**
 * Avisa quando a preferência MUDA, e devolve a função que cancela o aviso.
 *
 * A pessoa pode ligar a opção com a tela aberta -- e aí o certo é parar de
 * animar sem ela precisar recarregar nada.
 *
 * @param {(reduzido: boolean) => void} aoMudar
 * @returns {() => void}
 */
export function observarMovimentoReduzido(aoMudar) {
    let media;

    try {
        media = window.matchMedia && window.matchMedia(CONSULTA);
    } catch {
        media = null;
    }

    if (!media) return () => {};

    const ouvinte = (evento) => aoMudar(Boolean(evento.matches));

    // `addEventListener` é o jeito atual; `addListener` é o que o Safari
    // antigo entende. Sem o segundo, a preferência mudada no meio da sessão
    // simplesmente não chegaria -- sem erro nenhum.
    if (media.addEventListener) {
        media.addEventListener('change', ouvinte);
        return () => media.removeEventListener('change', ouvinte);
    }

    if (media.addListener) {
        media.addListener(ouvinte);
        return () => media.removeListener(ouvinte);
    }

    return () => {};
}

export default prefereMovimentoReduzido;
